import { Decoder, field, number, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../Resource/Decoders';
import { BulkLicensesReclaimed, BulkLicensesReclaimedResource } from '../Types';

const bulkLicensesReclaimedDecoder: Decoder<BulkLicensesReclaimed> = succeed({})
  .assign('userCount', field('user_count', number))
  .assign('reclaimedLicenseCount', field('reclaimed_license_count', number));

export const bulkLicensesReclaimedResourceDecoder: Decoder<BulkLicensesReclaimedResource> =
  resourceDecoder(bulkLicensesReclaimedDecoder);
